module.exports = __webpack_public_path__ + "dj.svg?addb4ed520b75ff1f321258159e7fda8";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/dj.svg
// module id = 1233
// module chunks = 27